/**
 * story-animation.js
 *
 * .story コンポーネント専用のスクロールアニメーション。
 * セレクタを .story 配下に限定することで他ページへの影響を排除。
 *
 * 元実装（jQuery Waypoints）の挙動：
 *   - offset: "100%" → 要素の上端がビューポート下端に達したタイミングで発火
 *   - "down" 方向のみ → スクロールダウン時のみ付与（上スクロールでは取り消さない）
 *   - DOM ready + window load の2回初期化
 *
 * 依存：なし（Vanilla JS / ES2015+）
 */

(function () {
  'use strict';

  // .story が存在しないページでは即終了（他ページへの影響ゼロ）
  var storyRoot = document.querySelector('.story');
  if (!storyRoot) return;

  /**
   * スクロール方向を追跡するユーティリティ
   */
  var lastScrollY = window.scrollY || window.pageYOffset;

  function getScrollDirection() {
    var currentScrollY = window.scrollY || window.pageYOffset;
    var direction = currentScrollY >= lastScrollY ? 'down' : 'up';
    lastScrollY = currentScrollY;
    return direction;
  }

  /**
   * IntersectionObserver を生成する共通ファクトリ
   *
   * @param {string} selector  - .story 配下の対象セレクタ
   * @param {string} className - 付与するクラス名
   */
  function createWaypointObserver(selector, className) {
    // querySelectorAll を storyRoot に限定することで他ページの同クラスに触れない
    var targets = storyRoot.querySelectorAll(selector);
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          // スクロールダウン方向のみ発火（元の "down" === e 条件を再現）
          if (getScrollDirection() !== 'down') return;

          entry.target.classList.add(className);

          // 一度付与したら監視を外す（元実装はクラスを取り消さないため）
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0, // 要素が1pxでも見えた瞬間 = offset:"100%" の再現
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });

    return observer;
  }

  /**
   * 初期化処理
   * window load 時にも実行することで、ページ読み込み時点で
   * すでにビューポート内にある要素も確実に拾う（元実装の2回初期化を再現）。
   * unobserve 済みの要素は再監視されないため二重付与は起きない。
   */
  function init() {
    createWaypointObserver('.wp', 'is-wp-active');
    createWaypointObserver('.wp-title', 'is-wp-title-active');
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // window load（画像読み込み完了後に再スキャン）
  window.addEventListener('load', init);

})();
